<script setup lang="ts">
    import { computed } from 'vue';
    import type { SmsSent } from '../../interfaces';

    const props = defineProps<{
        overview: SmsSent | null;
    }>();

    // Mirrors the legacy TextMessagesGeneralViewModel.js's TextMessageReplace: only the
    // newline-to-<br> conversion is ported here. The legacy version also swapped any
    // auto-detected link for a fixed placeholder shortened-URL string when UseUrlShortener
    // was on — that behavior is deliberately not ported (it depended on client-side regex
    // link-detection logic that's tangential to the preview itself).
    const previewBody = computed(() => (props.overview?.Body ?? '').replace(/\n/g, '<br />'));
</script>

<template>
    <div class="preview-devices device-phone text-message">
        <div class="device-body">
            <div class="screen">
                <div class="text-message-preview m-lg-b">
                    <span>
                        <strong class="d-block m-xs-b">{{ overview?.Sender }}</strong>
                        <span v-html="previewBody"></span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
